'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var utils = require('pobble-components/dist/utils');

var setup = require('pobble-components/dist/setup');

var env = utils.getPobbleEnv();
/**
 * Since we load all external tools lazily
 *  every method in this file has a fallback to queue
 *  in case if the tool hasn't loaded yet.
 *
 * When the tool is loaded it picks up a queue and executes it
 */

var gtmDataLayerQueue = [];

var gtmDataLayer = function gtmDataLayer(dataLayer) {
  var TagManager = window.POBBLE_EXTERNAL_TOOLS && window.POBBLE_EXTERNAL_TOOLS.gtm;

  if (!TagManager) {
    gtmDataLayerQueue.push(dataLayer);
  } else {
    if (dataLayer.userId) dataLayer.userId = "account_".concat(dataLayer.userId);
    TagManager.dataLayer({
      dataLayer: dataLayer
    });
    env !== 'prod' && console.info('Metrics: GTM data layer', dataLayer);
  }
};

var triggerUserflow = function triggerUserflow() {
  if (env !== 'local') {
    var _window$userflow;

    window.userflow && window.userflow.isIdentified() && (_window$userflow = window.userflow).start.apply(_window$userflow, arguments);
  }
};

var initUserFlowQueue = [];

var initUserFlow = function initUserFlow(id, data) {
  var userflow = window.POBBLE_EXTERNAL_TOOLS && window.POBBLE_EXTERNAL_TOOLS.userflow;

  if (!userflow) {
    initUserFlowQueue.push([id, data]);
  } else {
    userflow.setInferenceClassNameFilter(function (cls) {
      return cls.startsWith('metrics__');
    });
    userflow.init(env === 'prod' ? setup.CONSTANTS.USERFLOW_TOKEN.PROD : setup.CONSTANTS.USERFLOW_TOKEN.STG);
    userflow.identify(id, data);
    env !== 'prod' && console.info('Metrics: Initialize UserFlow', id, data);
  }
};

exports.gtmDataLayer = gtmDataLayer;
exports.gtmDataLayerQueue = gtmDataLayerQueue;
exports.initUserFlow = initUserFlow;
exports.initUserFlowQueue = initUserFlowQueue;
exports.triggerUserflow = triggerUserflow;